<template>
<div>
    <div v-if="showActivePackageSummary">
        <v-container flat style="text-align: center; padding-top:0;margin-top:0" id="packageList">
            <v-row justify="center" style="text-align: center; padding-top:0;margin-top:0">
                <v-col cols="12" sm="12" lg="9" xl="6" class="text-align:center">
                    <v-card shaped flat style="text-align: center; padding-top:0;margin-top:0">
                        <v-card-title class="headline" primary-title>
                            <v-btn icon @click="showActivePackageSummary=false, showToolbar()">
                                <v-icon>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <span :style="{ color: configData.secondaryColour }" class="mr-4 font-weight-bold">{{ activePackage.name }}</span>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <br />
                        <v-card-text style="padding:0;margin:0">
                            <v-row wrap align="center" justify="center" style="padding:0;margin:0">
                                <v-col cols="12" sm="12" md="4" xl="3" style="padding:0;margin:0">
                                    <v-row align="center" justify="center">
                                        <v-col cols="12" sm="12" class="text-xs-left px-0">
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-icon large color="light-green">cloud_download</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content style="text-align: left; color: grey">
                                                        <v-list-item-title>
                                                            {{
                                    activePackage.packagesFno.speedProfile
                                      .downloadMbps
                                  }}
                                                            Mbps
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-icon large color="light-blue">cloud_upload</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content style="text-align: left; color: grey">
                                                        <v-list-item-title>
                                                            {{
                                    activePackage.packagesFno.speedProfile
                                      .uploadMbps
                                  }}
                                                            Mbps
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-icon large>speed</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content style="text-align: left; color: grey">
                                                        <v-list-item-title>
                                                            <span v-if="activePackage.isCapped">Capped ({{
                                    activePackage.cappedAmountGb
                                  }}Gb)</span>
                                                            <span v-else>Uncapped</span>
                                                            <span v-if="activePackage.isShaped">
                                                                | Shaped</span>
                                                            <span v-else> | Unshaped</span>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-icon large>assignment</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content style="text-align: left; color: grey">
                                                        <v-list-item-title>
                                                            {{ activePackage.term }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-icon large>attach_money</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content style="text-align: left; color: grey">
                                                        <v-list-item-title>
                                                            <v-col cols="12" class="text-xs-left px-0">
                                                                <h4>
                                                                    <v-chip>{{
                                  activePackage.onceOffPriceVatInc | currency
                                }}</v-chip>
                                                                    Once off
                                                                </h4>
                                                                <h4 class="mt-1">
                                                                    <v-chip>{{
                                  activePackage.recurringPriceVatInc
                                    | currency
                                }}</v-chip>
                                                                    pm
                                                                </h4>
                                                            </v-col>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-col>

                                    </v-row>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" style="padding:0;margin:0">
                                    <v-img contain v-if="
                        activePackage.customerOrganisation&&
                          activePackage.customerOrganisation
                            .packageCardModalImage
                        " :src="
                          activePackage.customerOrganisation
                            .packageCardModalImage
                        " alt="" style="max-height: 150px"></v-img>
                                    <v-img v-else-if="activePackage.customerOrganisation" contain :src="
                          activePackage.customerOrganisation
                            .logo
                        " style="max-height: 150px" alt=""></v-img>
                                </v-col>
                            </v-row>
                            <v-row row wrap justify="center" v-if="
              activePackage.isPromotion &&
              activePackage.promotionDescription !== null &&
              activePackage.promotionDescription !== ''
            ">
                                <v-col style="text-align: left; padding: 15px">
                                    <h3 :style="{ color: configData.secondaryColour }">Promotion:</h3>
                                    <v-form>
                                        {{ activePackage.promotionDescription }}
                                    </v-form>
                                </v-col>
                            </v-row>
                            <v-row justify="start">
                                <v-col :cols="activePackage.specificTerms&&activePackage.description?6:activePackage.description?12:0" v-if="
                            activePackage.description !== null &&
                            activePackage.description !== ''
                          " style="text-align: left; padding: 15px">
                                    <v-form :style="{ color: configData.secondaryColour }">
                                        {{ activePackage.description }}
                                    </v-form>
                                </v-col>
                                <v-col cols="6" style="text-align: left; padding: 15px" v-if="
              activePackage.hasSpecificTerms &&
              activePackage.specificTerms !== null &&
              activePackage.specificTerms !== ''
            ">
                                    <h3 class="grey--text">Specific T's & C's:</h3>
                                    <v-form>
                                        {{ activePackage.specificTerms }}
                                    </v-form>
                                </v-col>
                            </v-row>
                            <!-- <v-row row wrap justify="center" >
                                
                            </v-row> -->

                            <v-container v-if="activePackage.isFup">
                                <v-row row wrap>
                                    <v-col style="text-align: left; padding: 15px">
                                        <h3 style="color: red">Please note!</h3>
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            This package comes with a
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <a target="_blank" :href="activePackage.customerOrganisation.fupUrl" @click.stop v-on="on">
                                                        Fair Usage Policy!
                                                    </a>
                                                </template>
                                                Open link to view Fair Usage Policy
                                            </v-tooltip>
                                        </v-form>
                                    </v-col>
                                </v-row>

                            </v-container>
                            <v-row justify='center'>
                                <v-btn rounded class="white--text" :color="$store.state.currentOrg.orderPrimaryColour
                                            ? $store.state.currentOrg.orderPrimaryColour
                                            : $store.state.currentOrg.primaryColour
                                        " @click="proceed()">Proceed <v-icon>chevron_right</v-icon>
                                </v-btn>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
    <div v-if="!showActivePackageSummary">

        <v-form>
            <v-form v-if="this.$vuetify.breakpoint.xsOnly">
                <v-container flat style="text-align: center" id="packageList">
                    <v-row justify="center">
                        <v-col cols="6" sm="6" v-for="item in paginate.filter((x) => x.customerOrganisation)" :key="item.id">
                            <transition-group name="list" tag="div">
                                <v-card shaped class="elevation-5" style="text-align: center; padding: 0px; cursor: pointer" :class="{
                  greenBorder:
                    item.id == keepColor &&
                    item.packagesFno.packagesFnoCat.packageCatType ===
                      'Residential',
                  redBorder: item.id == keepColor && item.isPromotion,
                  blueBorder:
                    item.id == keepColor &&
                    item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business',
                }" hover name="packageCard" @click="selectPackage(item.id, item)" :key="item.id">
                                    <v-toolbar height="20px" v-if="item.isPromotion" flat color="red">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 12px; text-align: center" class="white--text">
                                            PROMO DEAL </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="20px" class="text-xs-center" v-else-if="
                    item.packagesFno.packagesFnoCat.packageCatType ===
                    'Residential'
                  " flat color="primary">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 12px" class="white--text text-xs-center">
                                            RESIDENTIAL </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="20px" class="text-xs-center" v-else-if="
                    item.packagesFno.packagesFnoCat.packageCatType ===
                    'Business'
                  " flat color="light-blue lighten-2">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 12px" class="white--text text-xs-center">
                                            BUSINESS </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-responsive class="px-2 pt-1">
                                        <v-img v-if="item.customerOrganisation" :src="
                      item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                        ? item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                        : item.customerOrganisation.logo
                    " max-height="50" aspect-ratio="1.4" contain></v-img>
                                    </v-responsive>
                                    <v-card-text>
                                        <h3 v-if="item.isFup" style="text-align: center; font-size: 12px" :style="{ color: configData.secondaryColour }">
                                            <v-icon size="small">arrow_downward</v-icon>
                                            {{ item.packagesFno.speedProfile.downloadMbps }}
                                            <v-icon size="small">arrow_upward</v-icon>
                                            {{ item.packagesFno.speedProfile.uploadMbps }}
                                        </h3>
                                        <h3 v-if="!item.isFup" style="text-align: center; font-size: 12px" :style="{ color: configData.secondaryColour }">
                                            <v-icon size="small">arrow_downward</v-icon>
                                            {{ item.packagesFno.speedProfile.downloadMbps }}
                                            <v-icon size="small">arrow_upward</v-icon>
                                            {{ item.packagesFno.speedProfile.uploadMbps }}
                                        </h3>
                                        <br v-if="!item.isFup" />
                                        <span v-if="item.isFup">
                                            <v-chip style="font-size: 12px" small dark color="orange">FUP</v-chip>
                                        </span>
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            <h1 style="font-size: 14px">
                                                <span v-if="item.hasSpecificTerms">*</span>{{ item.recurringPriceVatInc | currency }} pm
                                            </h1>
                                        </v-form>
                                        <v-form :style="{ color: configData.secondaryColour }" class="py-2" style="font-size: 12px">{{ item.onceOffPriceVatInc | currency }} Once-off</v-form>
                                        <v-form :style="{ color: configData.secondaryColour }" style="font-size: 12px" class="text-uppercase">{{ item.term }}</v-form>
                                    </v-card-text>
                                    <v-btn small rounded v-if="item.isPromotion" @click="
                    showPackageMobile = true;
                    selectedPackage = item;
                    moreInfoClicked = true;
                  " text class="justify-center white--text" color="red">
                                        <v-icon medium>info</v-icon> Info
                                    </v-btn>
                                    <v-btn small rounded v-else-if="
                    item.packagesFno.packagesFnoCat.packageCatType ===
                    'Business'
                  " @click="
                    showPackageMobile = true;
                    selectedPackage = item;
                    moreInfoClicked = true;
                  " text class="justify-center white--text" color="light-blue lighten-2">
                                        <v-icon medium>info</v-icon> Info
                                    </v-btn>
                                    <v-btn small rounded v-else @click="
                    showPackageMobile = true;
                    selectedPackage = item;
                    moreInfoClicked = true;
                  " text class="justify-center white--text" color="primary">
                                        <v-icon medium>info</v-icon> Info
                                    </v-btn>
                                    <v-layout class="justify-center align-center" v-if="selectedId==item.id">
                                        <v-icon color="light-green">check_circle_outline</v-icon>
                                        <span class="justify-center align-center grey--text">Selected</span>
                                    </v-layout>
                                    <br v-if="selectedId!==item.id" /><br v-if="selectedId!==item.id" /><br />
                                </v-card>
                            </transition-group>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container style="text-align: center">
                    <v-row>
                        <v-col cols="4" sm="3">
                            <v-btn depressed v-if="currentPage !== 1 && totalPages > 1" small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-col>

                        <v-col cols="4" sm="3">
                            <v-btn depressed v-for="pageNumber in totalPages" v-if="currentPage === pageNumber && totalPages > 1" rounded small color="primary" @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="
                totalPages > 1 &&
                (pageNumber === currentPage + 1 ||
                  pageNumber === currentPage - 1 ||
                  (currentPage === 1 && pageNumber === 3) ||
                  (currentPage === totalPages && pageNumber === totalPages - 2))
              " small color="grey" text @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                        </v-col>
                        <v-col cols="4" sm="3">
                            <v-btn depressed v-if="(currentPage < totalPages) & (totalPages > 1)" small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>

            <div v-if="this.$vuetify.breakpoint.smOnly">
                <v-container max-width="200px" class="px-2" flat style="text-align: center px-0" id="packageList">
                    <v-row justify="center">
                        <v-col cols="4" sm="4" v-for="item in paginate" :key="item.id">
                            <transition-group name="list" tag="div">
                                <v-card shaped class="elevation-5" style="text-align: center; padding: 0px; cursor: pointer" :class="{
                greenBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType ===
                    'Residential',
                redBorder: item.id == keepColor && item.isPromotion,
                blueBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business',
              }" hover height="450px" max-width="200px" name="packageCard" @click="selectPackage(item.id, item)" :key="item.id">
                                    <v-toolbar height="35px" v-if="item.isPromotion" flat color="red">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            PROMO DEAL
                                        </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType ===
                  'Residential'
                " flat color="primary">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            RESIDENTIAL
                                        </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business'
                " flat color="light-blue lighten-2">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            BUSINESS </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-responsive class="pt-4 px-2">
                                        <v-img v-if="item.customerOrganisation" :src="
                    item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      ? item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      : item.customerOrganisation.logo
                  " max-height="50" aspect-ratio="1.4" contain></v-img>
                                    </v-responsive>
                                    <v-card-text>
                                        <v-form>
                                            <span :style="{ color: configData.secondaryColour }" v-if="item.isCapped">CAPPED</span>
                                            <span :style="{ color: configData.secondaryColour }" v-else>UNCAPPED</span>
                                            / <br />
                                            <span :style="{ color: configData.secondaryColour }" v-if="item.isShaped">
                                                SHAPED</span>
                                            <span :style="{ color: configData.secondaryColour }" v-else>UNSHAPED</span>
                                        </v-form>
                                        <v-form>
                                            <h3 v-if="item.isFup" style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                <v-icon>arrow_downward</v-icon>
                                                {{ item.packagesFno.speedProfile.downloadMbps }}
                                                <v-icon>arrow_upward</v-icon>
                                                {{ item.packagesFno.speedProfile.uploadMbps }}
                                                <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                Mbps
                                            </h3>
                                            <h3 v-else style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                <v-icon>arrow_downward</v-icon>
                                                {{ item.packagesFno.speedProfile.downloadMbps }}
                                                <v-icon>arrow_upward</v-icon>
                                                {{ item.packagesFno.speedProfile.uploadMbps }}
                                                <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                Mbps
                                            </h3>
                                            <v-chip style="font-size: 10px" small v-if="item.isFup" dark color="orange">FAIR USAGE POLICY</v-chip>
                                        </v-form>
                                        <br v-if="!item.isFup" />
                                        <v-divider v-if="item.isFup" class="mt-3"></v-divider>
                                        <v-divider v-else class="mt-4"></v-divider>
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            <h1 style="font-size: 20px">
                                                <span v-if="item.hasSpecificTerms">*</span>{{ item.recurringPriceVatInc | currency }}
                                            </h1>
                                            p/m
                                        </v-form>
                                        <v-divider></v-divider>
                                        <v-form :style="{ color: configData.secondaryColour }" class="py-2">{{ item.onceOffPriceVatInc | currency }} Once-off</v-form>
                                        <v-form :style="{ color: configData.secondaryColour }" style="font-size: 15px" class="text-uppercase">{{ item.term }}</v-form>
                                        <v-divider></v-divider>
                                    </v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-layout class="justify-center align-center">
                                                <v-btn small rounded v-if="item.isPromotion" @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="red">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                                <v-btn small rounded v-else-if="
                      item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business'
                    " @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="light-blue lighten-2">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                                <v-btn small rounded v-else @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="primary">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                            </v-layout>

                                            <v-layout class="justify-center align-center" v-if="selectedId==item.id">
                                                <v-icon color="light-green">check_circle_outline</v-icon>
                                                <span class="justify-center align-center grey--text">Selected</span>
                                            </v-layout>

                                        </v-col> <br />
                                    </v-row>

                                </v-card>
                            </transition-group>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container style="text-align: center">
                    <v-row justify="center">
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="currentPage !== 1 && totalPages > 1" small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-for="pageNumber in totalPages" v-if="currentPage === pageNumber && totalPages > 1" rounded small color="primary" @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="
                totalPages > 1 &&
                (pageNumber === currentPage + 1 ||
                  pageNumber === currentPage - 1 ||
                  (currentPage === 1 && pageNumber === 3) ||
                  (currentPage === totalPages && pageNumber === totalPages - 2))
              " small color="grey" text @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="(currentPage < totalPages) & (totalPages > 1)" small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-if="this.$vuetify.breakpoint.mdOnly">
                <v-container class="px-2" flat style="text-align: center px-0" id="packageList">
                    <v-row justify="center">
                        <v-col cols="3" v-for="item in paginate" :key="item.id">
                            <transition-group name="list" tag="div">
                                <v-card shaped class="elevation-5" style="text-align: center; padding: 0px; cursor: pointer" :class="{
                greenBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType ===
                    'Residential',
                redBorder: item.id == keepColor && item.isPromotion,
                blueBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business',
              }" hover height="450px" max-width="200px" name="packageCard" @click="selectPackage(item.id, item)" :key="item.id">
                                    <v-toolbar height="35px" v-if="item.isPromotion" flat color="red">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            PROMO DEAL
                                        </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType ===
                  'Residential'
                " flat color="primary">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            RESIDENTIAL
                                        </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business'
                " flat color="light-blue lighten-2">
                                        <v-spacer />
                                        <v-toolbar-title style="font-size: 18px" class="white--text">
                                            BUSINESS </v-toolbar-title>
                                        <v-spacer />
                                    </v-toolbar>
                                    <v-responsive class="pt-4 px-2">
                                        <v-img v-if="item.customerOrganisation" :src="
                    item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      ? item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      : item.customerOrganisation.logo
                  " max-height="50" aspect-ratio="1.4" contain></v-img>
                                    </v-responsive>
                                    <v-card-text>
                                        <v-form>
                                            <span :style="{ color: configData.secondaryColour }" v-if="item.isCapped">CAPPED</span>
                                            <span :style="{ color: configData.secondaryColour }" v-else>UNCAPPED</span>
                                            / <br />
                                            <span :style="{ color: configData.secondaryColour }" v-if="item.isShaped">
                                                SHAPED</span>
                                            <span :style="{ color: configData.secondaryColour }" v-else>UNSHAPED</span>
                                        </v-form>
                                        <v-form>
                                            <h3 v-if="item.isFup" style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                <v-icon>arrow_downward</v-icon>
                                                {{ item.packagesFno.speedProfile.downloadMbps }}
                                                <v-icon>arrow_upward</v-icon>
                                                {{ item.packagesFno.speedProfile.uploadMbps }}
                                                <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                Mbps
                                            </h3>
                                            <h3 v-else style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                <v-icon>arrow_downward</v-icon>
                                                {{ item.packagesFno.speedProfile.downloadMbps }}
                                                <v-icon>arrow_upward</v-icon>
                                                {{ item.packagesFno.speedProfile.uploadMbps }}
                                                <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                Mbps
                                            </h3>
                                            <v-chip style="font-size: 10px" small v-if="item.isFup" dark color="orange">FAIR USAGE POLICY</v-chip>
                                        </v-form>
                                        <br v-if="!item.isFup" />
                                        <v-divider v-if="item.isFup" class="mt-3"></v-divider>
                                        <v-divider v-else class="mt-4"></v-divider>
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            <h1 style="font-size: 20px">
                                                <span v-if="item.hasSpecificTerms">*</span>{{ item.recurringPriceVatInc | currency }}
                                            </h1>
                                            p/m
                                        </v-form>
                                        <v-divider></v-divider>
                                        <v-form :style="{ color: configData.secondaryColour }" class="py-2">{{ item.onceOffPriceVatInc | currency }} Once-off</v-form>
                                        <v-form :style="{ color: configData.secondaryColour }" style="font-size: 15px" class="text-uppercase">{{ item.term }}</v-form>
                                        <v-divider></v-divider>
                                    </v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-layout class="justify-center align-center">
                                                <v-btn small rounded v-if="item.isPromotion" @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="red">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                                <v-btn small rounded v-else-if="
                      item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business'
                    " @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="light-blue lighten-2">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                                <v-btn small rounded v-else @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="primary">
                                                    <v-icon medium>info</v-icon> Info
                                                </v-btn>
                                            </v-layout>
                                            <v-layout class="justify-center align-center" v-if="selectedId==item.id">
                                                <v-icon color="light-green">check_circle_outline</v-icon>
                                                <span class="justify-center align-center grey--text">Selected</span>
                                            </v-layout>
                                            <v-layout class="justify-center align-center" v-else>
                                                <v-btn small rounded v-if="item.isPromotion" color="red" class="white--text">
                                                    SELECT</v-btn>
                                                <v-btn small rounded v-else-if="
                      item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business'
                    " class="white--text" color="light-blue lighten-2">
                                                    SELECT</v-btn>
                                                <v-btn small rounded v-else color="primary">SELECT</v-btn>
                                            </v-layout>
                                        </v-col>
                                    </v-row>

                                </v-card>
                            </transition-group>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container style="text-align: center">
                    <v-row>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="currentPage !== 1 && totalPages > 1" small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-for="pageNumber in totalPages" v-if="currentPage === pageNumber && totalPages > 1" rounded small color="primary" @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="
                totalPages > 1 &&
                (pageNumber === currentPage + 1 ||
                  pageNumber === currentPage - 1 ||
                  (currentPage === 1 && pageNumber === 3) ||
                  (currentPage === totalPages && pageNumber === totalPages - 2))
              " small color="grey" text @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="(currentPage < totalPages) & (totalPages > 1)" small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </div>

            <div v-if="this.$vuetify.breakpoint.lgAndUp">
                <v-container class="px-2" flat style="text-align: center" id="packageList">
                    <v-row justify="center">
                        <v-col cols="12" lg="12" xl="12"  style="text-align: center">
                            <v-row justify="center">
                                <v-col cols="2" class="text-align:center" v-for="item in paginate" :key="item.id">
                                    
                                        <v-card shaped class="elevation-5" style="text-align: center; padding: 0px; cursor: pointer" :class="{
                greenBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType ===
                    'Residential',
                redBorder: item.id == keepColor && item.isPromotion,
                blueBorder:
                  item.id == keepColor &&
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business',
              }" hover height="450px" max-width="200px" min-width="150px" name="packageCard" @click="selectPackage(item.id, item)" :key="item.id">
                                            <v-toolbar height="35px" v-if="item.isPromotion" flat color="red">
                                                <v-spacer />
                                                <v-toolbar-title style="font-size: 18px" class="white--text">
                                                    PROMO DEAL
                                                </v-toolbar-title>
                                                <v-spacer />
                                            </v-toolbar>
                                            <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType ===
                  'Residential'
                " flat color="primary">
                                                <v-spacer />
                                                <v-toolbar-title style="font-size: 18px" class="white--text">
                                                    RESIDENTIAL
                                                </v-toolbar-title>
                                                <v-spacer />
                                            </v-toolbar>
                                            <v-toolbar height="35px" v-else-if="
                  item.packagesFno.packagesFnoCat.packageCatType === 'Business'
                " flat color="light-blue lighten-2">
                                                <v-spacer />
                                                <v-toolbar-title style="font-size: 18px" class="white--text">
                                                    BUSINESS </v-toolbar-title>
                                                <v-spacer />
                                            </v-toolbar>
                                            <v-responsive class="pt-4 px-2">
                                                <v-img v-if="item.customerOrganisation" :src="
                    item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      ? item.customerOrganisation&&item.customerOrganisation.packageCardLogo
                        
                      : item.customerOrganisation.logo
                  " max-height="50" aspect-ratio="1.4" contain></v-img>
                                            </v-responsive>
                                            <v-card-text>
                                                <v-form>
                                                    <span :style="{ color: configData.secondaryColour }" v-if="item.isCapped">CAPPED</span>
                                                    <span :style="{ color: configData.secondaryColour }" v-else>UNCAPPED</span>
                                                    / <br />
                                                    <span :style="{ color: configData.secondaryColour }" v-if="item.isShaped">
                                                        SHAPED</span>
                                                    <span :style="{ color: configData.secondaryColour }" v-else>UNSHAPED</span>
                                                </v-form>
                                                <v-form>
                                                    <h3 v-if="item.isFup" style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                        <v-icon>arrow_downward</v-icon>
                                                        {{ item.packagesFno.speedProfile.downloadMbps }}
                                                        <v-icon>arrow_upward</v-icon>
                                                        {{ item.packagesFno.speedProfile.uploadMbps }}
                                                        <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                        Mbps
                                                    </h3>
                                                    <h3 v-else style="font-size: 20px" :style="{ color: configData.secondaryColour }">
                                                        <v-icon>arrow_downward</v-icon>
                                                        {{ item.packagesFno.speedProfile.downloadMbps }}
                                                        <v-icon>arrow_upward</v-icon>
                                                        {{ item.packagesFno.speedProfile.uploadMbps }}
                                                        <br v-if="
                        item.packagesFno.speedProfile.downloadMbps <= 9 &&
                        item.packagesFno.speedProfile.uploadMbps <= 9
                      " />
                                                        Mbps
                                                    </h3>
                                                    <v-chip style="font-size: 10px" small v-if="item.isFup" dark color="orange">FAIR USAGE POLICY</v-chip>
                                                </v-form>

                                                <br v-if="!item.isFup" />
                                                <v-divider v-if="item.isFup" class="mt-3"></v-divider>
                                                <v-divider v-else class="mt-4"></v-divider>
                                                <v-form :style="{ color: configData.secondaryColour }">
                                                    <h1 style="font-size: 20px">
                                                        <span v-if="item.hasSpecificTerms">*</span>{{ item.recurringPriceVatInc | currency }}
                                                    </h1>
                                                    p/m
                                                </v-form>
                                                <v-divider></v-divider>
                                                <v-form :style="{ color: configData.secondaryColour }" class="py-2">{{ item.onceOffPriceVatInc | currency }} Once-off</v-form>
                                                <v-form :style="{ color: configData.secondaryColour }" style="font-size: 13px" class="text-uppercase">{{ item.term }}</v-form>
                                                <v-divider></v-divider>
                                            </v-card-text>

                                            <v-row>
                                                <v-col cols="12" sm="12">
                                                    <v-layout class="justify-center align-center">
                                                        <v-btn small rounded v-if="item.isPromotion" @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="red">
                                                            <v-icon medium>info</v-icon> Info
                                                        </v-btn>
                                                        <v-btn small rounded v-else-if="
                      item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business'
                    " @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="light-blue lighten-2">
                                                            <v-icon medium>info</v-icon> Info
                                                        </v-btn>
                                                        <v-btn small rounded v-else @click="
                      showPackage = true;
                      selectedPackage = item;
                      moreInfoClicked = true;
                    " text class="white--text pl-0" color="primary">
                                                            <v-icon medium>info</v-icon> Info
                                                        </v-btn>
                                                    </v-layout>
                                                    <v-layout class="justify-center align-center" v-if="selectedId==item.id">
                                                        <v-icon color="light-green">check_circle_outline</v-icon>
                                                        <span class="justify-center align-center grey--text">Selected</span>
                                                    </v-layout>
                                                    <v-layout v-else class="justify-center align-center">
                                                        <v-btn small rounded v-if="item.isPromotion" color="red" class="white--text">
                                                            SELECT</v-btn>
                                                        <v-btn small rounded v-else-if="
                      item.packagesFno.packagesFnoCat.packageCatType ===
                      'Business'
                    " class="white--text" color="light-blue lighten-2">
                                                            SELECT</v-btn>
                                                        <v-btn small rounded v-else color="primary">SELECT</v-btn>
                                                    </v-layout>
                                                </v-col>
                                            </v-row>

                                        </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                </v-container>
                <v-container style="text-align: center">
                    <v-row>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="currentPage !== 1 && totalPages > 1" small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage - 1)">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-for="pageNumber in totalPages" v-if="currentPage === pageNumber && totalPages > 1" rounded small color="primary" @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="
                totalPages > 1 &&
                (pageNumber === currentPage + 1 ||
                  pageNumber === currentPage - 1 ||
                  (currentPage === 1 && pageNumber === 3) ||
                  (currentPage === totalPages && pageNumber === totalPages - 2))
              " small color="grey" text @click="setPage(pageNumber)">{{ pageNumber }}</v-btn>
                        </v-col>
                        <v-col cols="6" sm="4">
                            <v-btn depressed v-if="(currentPage < totalPages) & (totalPages > 1)" small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                            <v-btn depressed v-else v-show="totalPages > 1" disabled small color="grey" text @click="setPage(currentPage + 1)">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                </v-container>

            </div>

            <!-- Modals -->
            <!-- package View modal -->
            <v-dialog v-model="showPackage" min-width="200px" max-width="900px">
                <v-card shaped>
                    <v-card-title class="headline" primary-title>
                        <v-img v-if="selectedPackage.customerOrganisation" :src="
              selectedPackage.customerOrganisation.packageCardLogo
                ? selectedPackage.customerOrganisation.packageCardLogo
                : selectedPackage.customerOrganisation.logo
            " px-5 max-height="55" aspect-ratio="1.4" contain style="text-align: left"></v-img>
                        <v-spacer></v-spacer>
                        <span :style="{ color: configData.secondaryColour }" class="mr-4 font-weight-bold">{{ selectedPackage.name }}</span>
                        <v-btn text @click="
              showPackage = false;
              moreInfoClicked = false;
            ">
                            X
                        </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <br />
                    <v-card-text>
                        <v-row wrap align="center">
                            <v-col cols="12" sm="12" md="4">
                                <v-row align="center">
                                    <v-col cols="12" sm="12" class="text-xs-left px-0">
                                        <v-row align="center">
                                            <v-col cols="6" sm="3">
                                                <h4>
                                                    <v-icon large color="light-green">cloud_download</v-icon>
                                                </h4>
                                            </v-col>
                                            <v-col cols="6" sm="9">
                                                <h4>
                                                    <span>{{
                                    selectedPackage.packagesFno.speedProfile
                                      .downloadMbps
                                  }}
                                                        Mbps</span>
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center">
                                            <v-col cols="6" sm="3">
                                                <h4>
                                                    <v-icon large color="light-blue">cloud_upload</v-icon>
                                                </h4>
                                            </v-col>
                                            <v-col cols="6" sm="9">
                                                <h4>
                                                    <span>{{
                                    selectedPackage.packagesFno.speedProfile
                                      .uploadMbps
                                  }}
                                                        Mbps</span>
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center">
                                            <v-col cols="6" sm="3">
                                                <h4>
                                                    <v-icon large>speed</v-icon>
                                                </h4>
                                            </v-col>
                                            <v-col cols="6" sm="9">
                                                <h4>
                                                    <span v-if="selectedPackage.isCapped">Capped ({{
                                    selectedPackage.cappedAmountGb
                                  }}Gb)</span>
                                                    <span v-else>Uncapped</span>
                                                    <span v-if="selectedPackage.isShaped">
                                                        | Shaped</span>
                                                    <span v-else> | Unshaped</span>
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center">
                                            <v-col cols="6" sm="3">
                                                <h4>
                                                    <v-icon large>assignment</v-icon>
                                                </h4>
                                            </v-col>
                                            <v-col cols="6" sm="9">
                                                <h4>
                                                    <b>{{ selectedPackage.term }}</b>
                                                </h4>
                                            </v-col>
                                        </v-row>

                                        <v-row align="center">
                                            <v-col cols="6" sm="3">
                                                <h4>
                                                    <v-icon large>attach_money</v-icon>
                                                </h4>
                                            </v-col>
                                            <v-col cols="6" sm="9" class="text-xs-left px-0">
                                                <h4>
                                                    <v-chip>{{
                                  selectedPackage.onceOffPriceVatInc | currency
                                }}</v-chip>
                                                    Once off
                                                </h4>
                                                <h4 class="mt-1">
                                                    <v-chip>{{
                                  selectedPackage.recurringPriceVatInc
                                    | currency
                                }}</v-chip>
                                                    pm
                                                </h4>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="
                            selectedPackage.description !== null &&
                            selectedPackage.description !== ''
                          " style="text-align: left; padding: 15px">
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            {{ selectedPackage.description }}
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="12" md="8">
                                <v-img contain v-if="
                        selectedPackage.customerOrganisation&&
                          selectedPackage.customerOrganisation
                            .packageCardModalImage
                        " :src="
                          selectedPackage.customerOrganisation
                            .packageCardModalImage
                        " alt=""></v-img>
                                <v-img v-else-if="selectedPackage.customerOrganisation" contain :src="
                          selectedPackage.customerOrganisation
                            .logo
                        " alt=""></v-img>
                                <!-- <v-card v-else style="
    background: #3A1C71;
    background: -webkit-linear-gradient(to right, #FFAF7B, #D76D77, #3A1C71);
    background: linear-gradient(to right, #FFAF7B, #D76D77, #3A1C71);
  "></v-card> -->
                            </v-col>
                        </v-row>
                        <v-row row wrap v-if="
              selectedPackage.isPromotion &&
              selectedPackage.promotionDescription !== null &&
              selectedPackage.promotionDescription !== ''
            ">
                            <v-col style="text-align: left; padding: 15px">
                                <h3 :style="{ color: configData.secondaryColour }">Promotion:</h3>
                                <v-form>
                                    {{ selectedPackage.promotionDescription }}
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row row wrap v-if="
              selectedPackage.hasSpecificTerms &&
              selectedPackage.specificTerms !== null &&
              selectedPackage.specificTerms !== ''
            ">
                            <v-col style="text-align: left; padding: 15px">
                                <h3 class="grey--text">Specific T's & C's:</h3>
                                <v-form>
                                    {{ selectedPackage.specificTerms }}
                                </v-form>
                            </v-col>
                        </v-row>

                        <v-container v-if="selectedPackage.isFup">
                            <v-row row wrap>
                                <v-col style="text-align: left; padding: 15px">
                                    <h3 style="color: red">Please note!</h3>
                                    <v-form :style="{ color: configData.secondaryColour }">
                                        This package comes with a
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <a target="_blank" :href="selectedPackage.customerOrganisation.fupUrl" @click.stop v-on="on">
                                                    Fair Usage Policy!
                                                </a>
                                            </template>
                                            Open link to view Fair Usage Policy
                                        </v-tooltip>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!--////////////-->

            <v-dialog v-model="showPackageMobile" persistent fullscreen>
                <transition name="fade" appear>
                    <v-card>
                        <v-toolbar color="white">
                            <v-toolbar-title class="compact-formInfo">
                                <span :style="{ color: configData.secondaryColour }" class="font-weight-bold" style="font-size: 15px">{{ selectedPackage.name }}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn class="compact-formInfo" small color="primary" @click="
              showPackageMobile = false;
              moreInfoClicked = false;
            ">
                                <v-icon small>clear</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="12" sm="12" class="text-xs-left px-0">
                                    <v-col cols="12" sm="12" md="8">
                                        <v-img class="rounded-card" contain v-if="
                          selectedPackage.customerOrganisation&&selectedPackage.customerOrganisation
                            .packageCardModalImage
                        " :src="
                          selectedPackage.customerOrganisation
                            .packageCardModalImage
                        " alt=""></v-img>
                                        <v-img v-else-if="selectedPackage.customerOrganisation" contain :src="
                          selectedPackage.customerOrganisation
                            .logo
                        " alt=""></v-img>
                                    </v-col>
                                    <v-row align="center">
                                        <v-col cols="6" sm="3">
                                            <h4>
                                                <v-icon large color="light-green">cloud_download</v-icon>
                                            </h4>
                                        </v-col>
                                        <v-col cols="6" sm="9">
                                            <h4>
                                                <span>{{
                                    selectedPackage.packagesFno.speedProfile
                                      .downloadMbps
                                  }}
                                                    Mbps</span>
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row align="center">
                                        <v-col cols="6" sm="3">
                                            <h4>
                                                <v-icon large color="light-blue">cloud_upload</v-icon>
                                            </h4>
                                        </v-col>
                                        <v-col cols="6" sm="9">
                                            <h4>
                                                <span>{{
                                    selectedPackage.packagesFno.speedProfile
                                      .uploadMbps
                                  }}
                                                    Mbps</span>
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row align="center">
                                        <v-col cols="6" sm="3">
                                            <h4>
                                                <v-icon large>speed</v-icon>
                                            </h4>
                                        </v-col>
                                        <v-col cols="6" sm="9">
                                            <h4>
                                                <span v-if="selectedPackage.isCapped">Capped ({{
                                    selectedPackage.cappedAmountGb
                                  }}Gb)</span>
                                                <span v-else>Uncapped</span>
                                                <span v-if="selectedPackage.isShaped">
                                                    | Shaped</span>
                                                <span v-else> | Unshaped</span>
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row align="center">
                                        <v-col cols="6" sm="3">
                                            <h4>
                                                <v-icon large>assignment</v-icon>
                                            </h4>
                                        </v-col>
                                        <v-col cols="6" sm="9">
                                            <h4>
                                                <b>{{ selectedPackage.term }}</b>
                                            </h4>
                                        </v-col>
                                    </v-row>

                                    <v-row align="center">
                                        <v-col cols="6" sm="3">
                                            <h4>
                                                <v-icon large>attach_money</v-icon>
                                            </h4>
                                        </v-col>
                                        <v-col cols="6" sm="9" class="text-xs-left px-0">
                                            <h4>
                                                <v-chip>{{
                                  selectedPackage.onceOffPriceVatInc | currency
                                }}</v-chip>
                                                Once off
                                            </h4>
                                            <h4 class="mt-1">
                                                <v-chip>{{
                                  selectedPackage.recurringPriceVatInc
                                    | currency
                                }}</v-chip>
                                                pm
                                            </h4>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <v-col cols="12" sm="12" v-if="
                            selectedPackage.description !== null &&
                            selectedPackage.description !== ''
                          " style="text-align: left; padding: 15px">
                                    <v-form :style="{ color: configData.secondaryColour }">
                                        {{ selectedPackage.description }}
                                    </v-form>
                                </v-col>
                            </v-row>

                            <v-row row wrap v-if="
              selectedPackage.isPromotion &&
              selectedPackage.promotionDescription !== null &&
              selectedPackage.promotionDescription !== ''
            ">
                                <v-col style="text-align: left; padding: 15px">
                                    <h3 :style="{ color: configData.secondaryColour }">Promotion:</h3>
                                    <v-form>
                                        {{ selectedPackage.promotionDescription }}
                                    </v-form>
                                </v-col>
                            </v-row>
                            <v-row row wrap v-if="
              selectedPackage.hasSpecificTerms &&
              selectedPackage.specificTerms !== null &&
              selectedPackage.specificTerms !== ''
            ">
                                <v-col style="text-align: left; padding: 15px">
                                    <h3 class="grey--text">Specific T's & C's:</h3>
                                    <v-form>
                                        {{ selectedPackage.specificTerms }}
                                    </v-form>
                                </v-col>
                            </v-row>

                            <v-container v-if="selectedPackage.isFup">
                                <v-row row wrap>
                                    <v-col style="text-align: left; padding: 15px">
                                        <h3 style="color: red">Please note!</h3>
                                        <v-form :style="{ color: configData.secondaryColour }">
                                            This package comes with a
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <a target="_blank" :href="selectedPackage.customerOrganisation.fupUrl" @click.stop v-on="on">
                                                        Fair Usage Policy!
                                                    </a>
                                                </template>
                                                Open link to view Fair Usage Policy
                                            </v-tooltip>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </transition>
            </v-dialog>

            <!-- Warning modal -->
            <v-dialog v-model="selectedPackageWarningModal">
                <v-card>
                    <v-card-title :style="{ color: configData.secondaryColour }" class="headline lighten-2" primary-title>
                        <b>Confirmation of selection</b>
                    </v-card-title>
                    <v-card-text>
                        Please confirm that you have selected an internet package.
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="danger" text @click="
              selectedPackageWarningModal = false;
              clearPackageSelection();
            ">
                            No
                        </v-btn>
                        <v-btn color="primary" text @click="selectedPackageWarningModal = false">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
    </div>

    <v-dialog v-model="showActivePackageSummaryModal" fullscreen>
        <v-card v-if="activePackage&&activePackage.packagesFno">
            <v-toolbar>

                <v-btn icon @click="showActivePackageSummaryModal=false, showToolbar()">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>
                    <span :style="{ color: configData.secondaryColour }" class="mr-4 font-weight-bold">{{ activePackage.name }}</span>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text style="padding:0;margin:0">
                <v-list>
                    <v-col cols="12">
                        <v-img contain v-if="
                        activePackage.customerOrganisation&&
                          activePackage.customerOrganisation
                            .packageCardModalImage
                        " :src="
                          activePackage.customerOrganisation
                            .packageCardModalImage
                        " alt="" style="max-height: 150px"></v-img>
                        <v-img v-else-if="activePackage.customerOrganisation" contain :src="
                          activePackage.customerOrganisation
                            .logo
                        " style="max-height: 150px" alt=""></v-img>
                    </v-col>
                    <v-row wrap align="center" justify="center" style="padding:0;margin:0">
                        <v-col cols="12" sm="12" md="4" xl="3" style="padding:0;margin:0">
                            <v-row align="center" justify="center">

                                <v-col cols="12" sm="12" v-if="
                            activePackage.description !== null &&
                            activePackage.description !== ''
                          " style="text-align: left; padding: 15px">
                                    <v-form :style="{ color: configData.secondaryColour }">
                                        {{ activePackage.description }}
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-col>

                    </v-row>
                    <v-row row wrap justify="center" v-if="
              activePackage.isPromotion &&
              activePackage.promotionDescription !== null &&
              activePackage.promotionDescription !== ''
            ">
                        <v-col style="text-align: left; padding: 15px">
                            <h3 :style="{ color: configData.secondaryColour }">Promotion:</h3>
                            <v-form>
                                {{ activePackage.promotionDescription }}
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon large color="light-green">cloud_download</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{
                                    activePackage.packagesFno.speedProfile
                                      .downloadMbps
                                  }}
                                Mbps
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon large color="light-blue">cloud_upload</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{
                                    activePackage.packagesFno.speedProfile
                                      .uploadMbps
                                  }}
                                Mbps
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon large>speed</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span v-if="activePackage.isCapped">Capped ({{
                                    activePackage.cappedAmountGb
                                  }}Gb)</span>
                                <span v-else>Uncapped</span>
                                <span v-if="activePackage.isShaped">
                                    | Shaped</span>
                                <span v-else> | Unshaped</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-icon large>assignment</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ activePackage.term }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-icon large>attach_money</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                <v-col cols="12" class="text-xs-left px-0">
                                    <h4>
                                        <v-chip>{{
                                  activePackage.onceOffPriceVatInc | currency
                                }}</v-chip>
                                        Once off
                                    </h4>
                                    <h4 class="mt-1">
                                        <v-chip>{{
                                  activePackage.recurringPriceVatInc
                                    | currency
                                }}</v-chip>
                                        pm
                                    </h4>
                                </v-col>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-row row wrap justify="center" v-if="
              activePackage.hasSpecificTerms &&
              activePackage.specificTerms !== null &&
              activePackage.specificTerms !== ''
            ">
                    <v-col style="text-align: left; padding: 15px">
                        <h3 class="grey--text">Specific T's & C's:</h3>
                        <v-form>
                            {{ activePackage.specificTerms }}
                        </v-form>
                    </v-col>
                </v-row>

                <v-container v-if="activePackage.isFup">
                    <v-row row wrap>
                        <v-col style="text-align: left; padding: 15px">
                            <h3 style="color: red">Please note!</h3>
                            <v-form :style="{ color: configData.secondaryColour }">
                                This package comes with a
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <a target="_blank" :href="activePackage.customerOrganisation.fupUrl" @click.stop v-on="on">
                                            Fair Usage Policy!
                                        </a>
                                    </template>
                                    Open link to view Fair Usage Policy
                                </v-tooltip>
                            </v-form>
                        </v-col>
                    </v-row>

                </v-container>
                <v-row justify='center'>
                    <v-btn rounded class="white--text" :color="$store.state.currentOrg.orderPrimaryColour
                                            ? $store.state.currentOrg.orderPrimaryColour
                                            : $store.state.currentOrg.primaryColour
                                        " @click="proceed()">Proceed <v-icon>chevron_right</v-icon>
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
export default {
    props: ["packagesIsps", "cardsPerPage", "sizeScreen", "keepColor", "preSelectedPackage"],
    data() {
        return {
            contentProps: {
                wrap: false,
                row: false,
            },
            pageNumber: 0,
            showPackageMobile: false,
            currentPage: 1,
            itemsPerPage: this.cardsPerPage,
            resultCount: 0,
            show: false,
            showPackage: false,
            moreInfoClicked: false,
            selectedPackageWarningModal: false,
            selectedId: null,
            selectedPackage: {
                customerOrganisation: {},
                locationNetwork: {},
                packagesFno: {
                    speedProfile: {},
                },
            },
            activePackage: {},
            packageObj: {},
            styleTrue: true,
            showActivePackageSummary: false,
            showActivePackageSummaryModal: false
        };
    },
    computed: {
        totalPages: function () {
            return Math.ceil(this.resultCount / this.cardsPerPage);
        },
        paginate: function () {
            if (
                !this.packagesIsps ||
                this.packagesIsps.length != this.packagesIsps.length
            ) {
                return;
            }

            this.resultCount = this.packagesIsps.length;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.cardsPerPage - this.cardsPerPage;
            return this.packagesIsps.slice(index, index + this.cardsPerPage);
        },
    },
    created() {
        if (this.preSelectedPackage) {
            this.selectedId = this.preSelectedPackage.id
        }
        console.log(this.$vuetify.breakpoint)
    },
    methods: {
        setPage: function (pageNumber) {
            this.currentPage = pageNumber;
        },
        clearPackageSelection() {
            let elements = document.getElementsByName("packageCard");
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.border = "none";
                elements[i].style.backgroundColor = "white";
            }
        },
        proceed() {
            console.log('Proceed')
            this.showActivePackageSummaryModal = false
            this.showActivePackageSummary = false
            this.$emit('proceed', this.activePackage)
        },
        hideToolbar() {
            this.$emit('hideToolbar')
        },
        showToolbar() {
            this.$emit('showToolbar')
        },
        selectPackage(id, obj) {
            if (!this.moreInfoClicked) {
                // this.clearPackageSelection();
                if (id != this.selectedId) {
                    this.selectedId = id;
                    this.activePackage = obj
                    if (this.$vuetify.breakpoint.xs) {
                        this.showActivePackageSummaryModal = true
                        this.showActivePackageSummary = false

                    } else {
                        this.showActivePackageSummary = true
                        this.showActivePackageSummaryModal = false

                    }
                    this.hideToolbar()

                    // document.getElementById(id).style.backgroundColor = "#e6e6e6";

                    // if (
                    //   !obj.isPromotion &&
                    //   obj.packagesFno.packagesFnoCat.packageCatType === "Residential"
                    // ) {
                    //   document.getElementById(id).style.border =
                    //     "1px solid " + this.$vuetify.theme.themes.light.primary
                    // } else if (
                    //   !obj.isPromotion &&
                    //   obj.packagesFno.packagesFnoCat.packageCatType === "Business"
                    // ) {
                    //   document.getElementById(id).style.border = "1px solid #34c3eb";
                    // } else if (obj.isPromotion) {
                    //   document.getElementById(id).style.border = "1px solid #e60000";
                    // }
                    this.$emit("selectPackage", obj);
                } else if (id == this.selectedId) {
                    this.selectedId = null;
                    this.$emit("selectPackage", null);
                }
            }
        },
    },
};
</script>

<style>
@media only screen and (min-width: 1904px) {
    .container {
        max-width: none !important;
    }
}

.mobileStep {
    font-size: 10px;
}

.largeStep {
    text-align: center;
    min-height: 470px;
    max-width: 160px;
}

.compact-form {
    transform: scale(0.8);
    transform-origin: top;
}

.compact-formInfo {
    transform-origin: top;
}

.greenBorder {
    background-color: #e6e6e6;
    border: 1px solid var(--primary);
    text-align: center;
}

.blueBorder {
    background-color: #e6e6e6;
    border: 1px solid #34c3eb;
    text-align: center;
}

.redBorder {
    background-color: #e6e6e6;
    border: 1px solid red;
    text-align: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.rounded-card {
    border-radius: 50px;
}

.list-item {
    display: inline-block;
    margin-right: 10px;
}

.list-enter-active,
.list-leave-active {
    transition: all 5s;
}

.list-enter,
.list-leave-to

/* .list-leave-active below version 2.1.8 */
    {
    opacity: 0;
    transform: translateY(30px);
}
</style>
